/**
 * 로비와 대기실에 걸리는 에피소드 소개.
 *
 * 제목과 도입부가 `main.ts` 와 `lobby.ts` 두 곳에 **하드코딩되어 있었다.**
 * 에피소드가 늘면 여기에 id 별로 더한다.
 *
 * **방마다 다른 사건이 도므로 상수로 고를 수 없다.** 처음엔 `ACTIVE` 를 봤는데,
 * 로비에서 초치성을 골라도 대기실 제목만 「사흘」로 남았다 — 방은 초치성인데
 * 화면만 사흘이라 제일 헷갈리는 종류의 버그였다. 부르는 쪽이 사건 id 를 준다.
 *
 * ## 도입부가 둘인 이유
 *
 * 로비 카드는 이름을 넣는 좁은 상자라 세 줄이 한계고, 대기실은 사람을 기다리며
 * 읽는 화면이라 길어도 된다. 같은 이야기를 다른 호흡으로 두 번 쓴다.
 *
 * 두 편 다 **마지막 줄이 위화감**이다. 그것이 이 게임의 문법이다 —
 * 「죽은 지 사흘이 지났다는데 다들 어제 이야기했다」, 「짐승이 죽였다는데
 * 자물쇠가 멀쩡히 열려 있다」. 답이 아니라 걸리는 것을 남기고 시작한다.
 */


export interface EpisodeText {
  title: string;
  /** 로비 카드 — 세 줄. `<br>` 와 `<b>` 만 쓴다 */
  short: string;
  /** 대기실 — 길어도 된다 */
  long: string;
}

const SAHOL: EpisodeText = {
  title: '사흘',
  short:
    '강원 산간의 폐교. 여섯이 2년째 산다.<br>' +
    '12월 19일 밤, 대표가 붙박이장 안에서 발견됐다. <b>죽은 지 사흘이 지났다고 했다.</b><br>' +
    '그런데 다섯 사람 전부, 그저께도 어제도 그와 이야기를 했다.',
  long:
    '강원 산간, 인구 340명. 1998년에 문 닫은 분교를 고쳐 청년 여섯이 2년째 산다.<br>' +
    '12월 19일 밤, 대표가 붙박이장 안에서 발견됐다.<br><br>' +
    '<b>사망한 지 사흘이 지났다고 했다.</b><br>' +
    '그런데 다섯 사람 전부, 그저께도 어제도 그와 이야기를 했다.',
};

export function episodeText(id: string | undefined): EpisodeText {
  void id;
  return SAHOL;
}
